/**
 * External Imports
 */
import styled from 'styled-components';

export const StyledLabelLoader = styled.span`
  font-size: 14px;
  line-height: 22px;
  margin-right: 2px;
  padding-top: 7px;
  padding-bottom: 8px;
`;
